// useOpenerData — the zero-LLM "remembers you" payload (ledger row 2,
// rescoped issue #20). Cheap tenant-scoped reads, no model call: the
// product decision in TutorService.start_session stands (LLM cold-opens
// were tried and removed — token cost + ambush tone). The OPENER is
// computed; the agent only engages when the learner taps a starter.
import React from 'react';
import { apiService } from '../../services/api';

export default function useOpenerData() {
  const [data, setData] = React.useState({ status: 'loading' });

  React.useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const coursesRes = await apiService.getUserCourses();
        const courses = coursesRes?.data || [];
        if (!courses.length) {
          if (alive) setData({ status: 'new-user' });
          return;
        }
        // Anchor on the most recently updated course.
        const course = [...courses].sort(
          (a, b) => new Date(b.updated_at || 0) - new Date(a.updated_at || 0),
        )[0];
        const code = course.code || course.id;

        const [masteryRes, streakRes, draftsRes] = await Promise.allSettled([
          apiService.getMasteryDashboard(code),
          apiService.getStreak(code),
          apiService.getPendingDrafts(),
        ]);
        const rows = masteryRes.status === 'fulfilled' ? masteryRes.value?.data || [] : [];
        const list = Array.isArray(rows) ? rows : rows.concepts || [];
        const due = list.filter((r) => r.due_for_review).length;
        const weakest = [...list]
          .filter((r) => typeof r.mastery_score === 'number')
          .sort((a, b) => a.mastery_score - b.mastery_score)[0] || null;
        const streak = streakRes.status === 'fulfilled'
          ? streakRes.value?.data || null
          : null;
        // A failed/500 drafts fetch degrades to count:0 — never breaks the opener.
        const pendingDrafts = draftsRes.status === 'fulfilled'
          ? draftsRes.value?.data || { count: 0 }
          : { count: 0 };

        if (alive) {
          setData({
            status: 'ready',
            course: { code, name: course.name },
            dueCount: due,
            weakest: weakest ? { concept: weakest.concept, score: weakest.mastery_score } : null,
            streak,
            pendingDrafts,
          });
        }
      } catch {
        // Opener data is a garnish — never block the chat on it.
        if (alive) setData({ status: 'fallback' });
      }
    })();
    return () => { alive = false; };
  }, []);

  return data;
}
